import { render } from "./social-media.vue?vue&type=template&id=4282f258&scoped=true"
import script from "./social-media.vue?vue&type=script&lang=js"
export * from "./social-media.vue?vue&type=script&lang=js"

import "./social-media.vue?vue&type=style&index=0&id=4282f258&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4282f258"]])

export default __exports__